import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Navigation, { Main } from "./components/Navigation"; // 🆕 Main შემოვიტანოთ აქედან
import AddProduct from "./components/addproduct";
import EditPerfume from "./components/editperfume";
import StockManager from "./components/StockManager";
import LoginPage from "./components/Login";
import axios from "axios";
import AddBrand from "./components/AddBrand";
import ManageBrands from "./components/ManageBrands";
import AllPerfumesSale from "./components/AllPerfumesSale";
import AllOrders from "./components/AllOrders";
import ProtectedRoutes from "./components/ProtectedRoutes";
import AddGiftCards from "./components/GiftCardAdd";
import CollectionsForm from "./components/CollectionsForm";
import CollectionAssign from "./components/CollectionAssign";
import GiftSetsAdmin from "./components/GiftSetsAdmin";
import AdminChangesToggle from './components/AdminChangesToggle';

const API_BASE_URL = "https://admin.shopaholics.ge/api";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/session_check.php`, { withCredentials: true });
        if (res.data?.user) {
          setUser(res.data.user);
          localStorage.setItem("user", JSON.stringify(res.data.user));
        } else {
          setUser(null);
          localStorage.removeItem("user");
        }
      } catch (error) {
        console.error("❌ Session check failed:", error);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
    const interval = setInterval(checkSession, 10000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      {!user ? (
        // 🔐 ულოგინო — მხოლოდ LoginPage
        <Routes>
          <Route path="*" element={<LoginPage setUser={setUser} />} />
        </Routes>
      ) : (
        // 🔐 ლოგინში — ნავიგაცია + Routes კონტენტი Main-ში (არ გადაიფარება Sidebar-ით)
        <>
          <Navigation />
          <Main>
            <Routes>
              <Route element={<ProtectedRoutes setUser={setUser} />}>
                <Route path="/" element={<Navigate to="/stockmanager" />} />
                <Route path="/add-product" element={<AddProduct />} />
                <Route path="/edit-product" element={<EditPerfume />} />
                <Route path="/stockmanager" element={<StockManager />} />
                <Route path="/AddBrand" element={<AddBrand />} />
                <Route path="/ManageBrands" element={<ManageBrands />} />
                <Route path="/AllPerfumesSale" element={<AllPerfumesSale />} />
                <Route path="/all-orders" element={<AllOrders />} />
                <Route path="/add-gift-cards" element={<AddGiftCards />} />
                <Route path="/add-collections" element={<CollectionsForm />} />
                <Route path="/add-item-to-collection" element={<CollectionAssign />} />
                <Route path="/gift-sets" element={<GiftSetsAdmin />} />
                <Route path="/changes" element={<AdminChangesToggle />} />
                <Route path="/login" element={<LoginPage />} />
              </Route>
            </Routes>
          </Main>
        </>
      )}
    </Router>
  );
};

export default App;
